(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-compare"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rp-compare')){
  customElements.define('rp-compare',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.tabs=Array.from(this.querySelectorAll('[data-compare-tab]'));
      this.panels=Array.from(this.querySelectorAll('[data-compare-panel]'));
      this.control=this.querySelector('[data-motion-control]');this.motionLabel=this.querySelector('[data-motion-label]');
      this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.userPaused=false;this.inView=false;
      this.onClick=e=>{const tab=e.target.closest('[data-compare-tab]');if(tab&&this.contains(tab))this.select(tab);if(e.target.closest('[data-motion-control]')){this.userPaused=!this.userPaused;this.updateMotion()}};
      this.onKey=e=>{const tab=e.target.closest('[data-compare-tab]');if(!tab)return;let i=this.tabs.indexOf(tab);if(e.key==='ArrowRight')i=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')i=(i-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')i=0;else if(e.key==='End')i=this.tabs.length-1;else return;e.preventDefault();this.select(this.tabs[i]);this.tabs[i].focus()};
      this.onVisibility=()=>this.updateMotion();this.onReduced=()=>this.updateMotion();
      this.addEventListener('click',this.onClick);this.addEventListener('keydown',this.onKey);document.addEventListener('visibilitychange',this.onVisibility);this.reduced.addEventListener('change',this.onReduced);
      this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.updateMotion()},{threshold:0});this.observer.observe(this);this.updateMotion();
    }
    select(tab){this.tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1});this.panels.forEach(p=>{p.hidden=p.dataset.comparePanel!==tab.dataset.compareTab});this.updateMotion()}
    updateMotion(){const paused=this.userPaused||this.reduced.matches||!this.inView||document.hidden;this.dataset.motion=paused?'paused':'playing';if(this.control){this.control.hidden=this.reduced.matches;this.control.setAttribute('aria-pressed',String(this.userPaused));this.motionLabel.textContent=this.userPaused?this.control.dataset.playLabel:this.control.dataset.pauseLabel}}
    disconnectedCallback(){this.observer?.disconnect();this.removeEventListener('click',this.onClick);this.removeEventListener('keydown',this.onKey);document.removeEventListener('visibilitychange',this.onVisibility);this.reduced?.removeEventListener('change',this.onReduced);this.ready=false}
  });
}

  } catch(e) { console.error(e); }
})();
})();
